import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { authSelector } from "../../utils/selectors";

const PrivateRoute = ({
  children,
  auth: { isAuthenticated, loading },
}) => {
  if (loading) return null;
  
  return !isAuthenticated ? <Navigate to="/" replace /> : children;
};

const mapStateToProps = (state) => ({
  auth: authSelector(state),
});

export default connect(mapStateToProps)(PrivateRoute);
